import React, { useState, useEffect, useCallback } from "react";

import "./HomeBroker.scss";
import { Box } from "@material-ui/core";
import TabList from "../../../../Components/TabList/TabList";
import Dashboard from "../Dashboard/Dashboard";
import {
  Avatar,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Modal,
  Grid,
  Link,
  Tabs,
  ToggleButton,
  Tooltip,
} from "@mui/material";
import Profile from "../Profile/Profile";
import Employees from "../Employees/Empolyees";
import Report from "../Report/Report";
import Claimassistant from "../Claimassistant/Claimassistant";
import Endorsement from "../Endorsement/Endorsement";

import Support from "../../Employee/Support/Support";
import Quotes from "../Quotes/Quotes";
import Policies from "../Policies/Policies";
import Clients from "../Clients/Clients";
import TaskManagement from "../TaskManagement/TaskManagement";
import ProductConfig from "../ProductConfig/ProductConfig";
import Contacts from "../Contacts/Contacts";
import NightsStayIcon from "@mui/icons-material/NightsStay";
import LightModeIcon from "@mui/icons-material/LightMode";
import { useNavigate } from "react-router-dom";
import TrendingQuestions from "../TrendingQuestions/TrendingQuestions";
import Community from "../Community/Community";
import GridViewIcon from "@mui/icons-material/GridView";
import PolicyRenewal from "../PolicyRenewal/PolicyRenewal";
import Notifications from "../../Common/Notifications/Notifications";
import KeyboardShotcuts from "../../../../Components/KeyboardShotcuts/KeyboardShotcuts";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import Session from "../../../../Session/Session";
import TuneIcon from "@mui/icons-material/Tune";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import { ControlCameraSharp } from "@mui/icons-material";
import Users from "../Settings/UserAndControl/Users/Users";

export default function HomeBroker() {
  const [shortcutOpen, setShortcutOpen] = useState(false);
  const [settingPage, setSettingPage] = useState("password");
  const [productConfigPage, setProductConfigPage] = useState("groupHealth");
  const [darkThemeStatus, setDarkThemeStatus] = React.useState(false);
  const [activePage, setActivePage] = useState("dashboard");
  const [searchopen, setSearchopen] = useState(false);
  const [searchType, setSearchType] = React.useState<string | null>("all");
  const toggleProduct = (
    event: React.SyntheticEvent,
    toggleProduct: string | null
  ) => {
    setSearchType(toggleProduct);
  };
  const navigate = useNavigate();

  //Add pop-up Status
  const [addQuoteStatus, setAddQuotes] = React.useState<boolean>(false);
  const [addPolicyStatus, setAddPolicyStatus] = React.useState<boolean>(false);
  const [addNewClient, setAddNewClient] = React.useState<boolean>(false);
  const [addNewContact, setAddNewContact] = React.useState<boolean>(false);
  const [addNewEmployee, setAddNewEmployee] = React.useState<boolean>(false);
  const [raiseNewRequest, setRaiseNewRequest] = React.useState<boolean>(false);
  const [intiateClaim, setIntiateClaim] = React.useState<boolean>(false);
  const [taskmanagement, setTaskManagement] = React.useState<boolean>(false);
  const [postQuery, setPostQuery] = React.useState<boolean>(false);
  const [postQuestion, setPostQuestion] = React.useState<boolean>(false);

  function updateMasterState(attrName: string, value: any) {
    switch (attrName) {
      case "activePage":
        setActivePage(value);
        break;
      case "shortcutOpen":
        setShortcutOpen(value);
        break;
      default:
        console.log(attrName, value);
        break;
    }
  }

  const [notificationMenuStatus, setNotificationMenuStatus] =
    useState<null | HTMLElement>(null);
  const openNotification = Boolean(notificationMenuStatus);
  const [userSignOutStatus, setUserSignOutStatus] =
    useState<null | HTMLElement>(null);
  const openSignOut = Boolean(userSignOutStatus);

  const handleClick = (
    event: React.MouseEvent<HTMLElement>,
    attrName: string
  ) => {
    if (attrName == "notificationMenuStatus") {
      setNotificationMenuStatus(event.currentTarget);
    } else if (attrName == "userSignOutStatus") {
      setUserSignOutStatus(event.currentTarget);
    }
  };
  const handleClose = (attrName: string) => {
    if (attrName == "notificationMenuStatus") {
      setNotificationMenuStatus(null);
    } else if (attrName == "userSignOutStatus") {
      setUserSignOutStatus(null);
    }
  };

  useEffect(() => {
    add_dark_theme();
    // toggle_dark_theme();
    window.addEventListener("load", add_dark_theme);

    // attach the event listener
    window.addEventListener("keydown", handleKeyPress);

    if (
      Session.getTokken().toString().length == 0 &&
      Session.getUserType() != "broker"
    ) {
      //navigate("/");

      const windowURL = window.location.search;
      const params = new URLSearchParams(windowURL);

      let page = params.get("page");
      if (page !== null) {
        setActivePage(page ?? "");
      }
    }
  }, []);

  const handleKeyPress = useCallback((e: any) => {
    var event = e;
    if (event.target.tagName !== "INPUT") {
      if (event.shiftKey) {
        switch (event.keyCode) {
          case 83:
            //s
            setShortcutOpen(true);
            break;
          case 81:
            //Q
            setActivePage("quote");
            setAddQuotes(true);
            break;
          case 80:
            //P
            setActivePage("policies");
            setAddPolicyStatus(true);
            break;
          case 67:
            //C
            setActivePage("clients");
            setAddNewClient(true);
            break;
          case 78:
            //N
            setActivePage("contacts");
            setAddNewContact(true);
            break;
          case 69:
            //E
            setActivePage("employe");
            setAddNewEmployee(true);
            break;
          case 84:
            //T
            setActivePage("endorsement");
            setRaiseNewRequest(true);
            break;
          case 22:
            //L
            setActivePage("claimassistant");
            setIntiateClaim(true);
            break;
          case 76:
            //G
            setActivePage("taskmanagement");
            setTaskManagement(true);
            break;
          case 71:
            //G
            setActivePage("trendingquestions");
            setPostQuery(true);
            break;
          case 77:
            //M
            setActivePage("community");
            setPostQuestion(true);
            break;
          default:
            break;
        }
      } else {
        switch (event.keyCode) {
          case 68:
            //D
            setActivePage("dashboard");
            break;
          case 81:
            //Q
            setActivePage("quote");
            setAddQuotes(false);
            break;
          case 80:
            //P
            setActivePage("policies");
            setAddPolicyStatus(false);
            break;
          case 82:
            //R
            setActivePage("policyrenewal");
            break;
          case 67:
            //C
            setActivePage("clients");
            setAddNewClient(false);
            break;
          case 78:
            //N
            setActivePage("contacts");
            setAddNewContact(false);
            break;
          case 69:
            //E
            setActivePage("employe");
            setAddNewEmployee(true);
            break;
          case 70:
            //F
            setActivePage("productConfig");
            break;
          case 84:
            //T
            setActivePage("endorsement");
            setRaiseNewRequest(false);
            break;
          case 76:
            //L
            setActivePage("claimassistant");
            setIntiateClaim(false);
            break;
          case 77:
            //M
            setActivePage("community");
            setPostQuestion(false);
            break;
          case 79:
            //O
            setActivePage("report");
            break;
          case 83:
            //S
            setSearchopen(true);
            break;
          case 85:
            //U
            setActivePage("support");
            break;
          case 71:
            //G
            setActivePage("trendingquestions");
            setPostQuery(false);
            break;
          case 71:
            //I
            setActivePage("setting");
            break;
          default:
            break;
        }
      }
    }
  }, []);

  // const add_dark_theme = (status: boolean) => {
  //   if (status == true) {
  //     document.body.classList.add("theme-dark");
  //   } else {
  //     document.body.classList.remove("theme-dark");
  //   }
  // };
  const isDark = localStorage.getItem("theme");

  const add_dark_theme = () => {
    const isDark = localStorage.getItem("theme") === "dark";
    if (isDark) {
      document.body.classList.add("theme-dark");
    } else {
      document.body.classList.remove("theme-dark");
    }
  };

  const toggle_dark_theme = () => {
    const isDark = localStorage.getItem("theme") === "dark";
    localStorage.setItem("theme", isDark ? "light" : "dark");
    add_dark_theme();
  };

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClicked = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClosed = () => {
    setAnchorEl(null);
  };

  return (
    <Box className="dashboardWrapper">
      {/* KeyboardShotcuts */}
      <Button
        className="shortcutBtn"
        onClick={() => {
          setShortcutOpen(true);
        }}
      />
      <KeyboardShotcuts
        openStatus={shortcutOpen}
        attrName="shortcutOpen"
        valueUpdate={updateMasterState}
      />

      <Button
        className="quickLaunch"
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClicked}
      >
        <GridViewIcon />
      </Button>
      <Menu
        className="showMenuBtns"
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClosed}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={handleClosed}>Add Client</MenuItem>
        <MenuItem onClick={handleClosed}>Add Employee</MenuItem>
        <MenuItem onClick={handleClosed}>Add Quote</MenuItem>
        <MenuItem onClick={handleClosed}>Add Policy</MenuItem>
      </Menu>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Grid className="logoCol" item xs>
              <img src="images/eb_logo.svg" />
            </Grid>
            <Grid className="topNavbar" item xs="auto">
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <Button
                    className="searchBox"
                    onClick={() => {
                      setSearchopen(true);
                    }}
                  >
                    Search here
                  </Button>
                </Grid>
                <Grid
                  container
                  justifyContent="flex-end"
                  alignItems="center"
                  item
                  xs={6}
                >
                  <Tooltip title="Task Management">
                    <Link
                      className="CustomModuleLink mr-5"
                      onClick={() => {
                        navigate("/TaskManagement");
                      }}
                    >
                      <AssignmentTurnedInOutlinedIcon />
                    </Link>
                  </Tooltip>

                  <Tooltip title="Settings">
                    <Link
                      className="CustomModuleLink mr-5"
                      onClick={() => {
                        navigate("/Settings");
                      }}
                    >
                      <TuneIcon />
                    </Link>
                  </Tooltip>

                  <Tooltip title="Appearence">
                    <Link
                      onClick={() => {
                        toggle_dark_theme();
                        setDarkThemeStatus(!darkThemeStatus);
                      }}
                      className="themeToggle mr-5"
                    >
                      {isDark == "light" ? (
                        <LightModeIcon />
                      ) : (
                        <NightsStayIcon />
                      )}
                    </Link>
                  </Tooltip>

                  {/* <-------Notification Menu Start --------> */}
                  <React.Fragment>
                    <Tooltip title="Notifications">
                      <Box className="notificationMenu">
                        <IconButton
                          className="bellIcon"
                          onClick={(e) => {
                            handleClick(e, "notificationMenuStatus");
                          }}
                          aria-controls={
                            openNotification ? "account-menu" : undefined
                          }
                          aria-haspopup="true"
                          aria-expanded={openNotification ? "true" : undefined}
                        >
                          <span className="number">0</span>
                        </IconButton>
                      </Box>
                    </Tooltip>

                    <Menu
                      className="notificationList"
                      anchorEl={notificationMenuStatus}
                      id="account-menu"
                      open={openNotification}
                      onClose={() => handleClose("notificationMenuStatus")}
                      onClick={() => handleClose("notificationMenuStatus")}
                      PaperProps={{
                        elevation: 0,
                        sx: {
                          overflow: "visible",
                          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                          mt: 1.5,
                          "& .MuiAvatar-root": {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                          },
                          "&:before": {
                            content: '""',
                            display: "block",
                            position: "absolute",
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: "background.paper",
                            transform: "translateY(-50%) rotate(45deg)",
                            zIndex: 0,
                          },
                        },
                      }}
                      transformOrigin={{ horizontal: "right", vertical: "top" }}
                      anchorOrigin={{
                        horizontal: "right",
                        vertical: "bottom",
                      }}
                    >
                      <Box className="menuWrapper">
                        <h5>Notifications</h5>
                        <MenuItem className="listItem">
                          <h6>Health Policy is process</h6>
                          <p>Your health policy has been processed.</p>
                        </MenuItem>
                        <MenuItem className="listItem">
                          <h6>Health Policy is process</h6>
                          <p>Your health policy has been processed.</p>
                        </MenuItem>
                        <MenuItem className="listItem">
                          <h6>Health Policy is process</h6>
                          <p>Your health policy has been processed.</p>
                        </MenuItem>
                        <MenuItem className="listItem">
                          <h6>Health Policy is process</h6>
                          <p>Your health policy has been processed.</p>
                        </MenuItem>
                        <MenuItem className="listItem">
                          <h6>Health Policy is process</h6>
                          <p>Your health policy has been processed.</p>
                        </MenuItem>
                        <MenuItem className="listItem">
                          <h6>Health Policy is process</h6>
                          <p>Your health policy has been processed.</p>
                        </MenuItem>
                        <MenuItem className="listItem">
                          <h6>Health Policy is process</h6>
                          <p>Your health policy has been processed.</p>
                        </MenuItem>
                        <MenuItem className="listItem">
                          <h6>Health Policy is process</h6>
                          <p>Your health policy has been processed.</p>
                        </MenuItem>
                        <MenuItem className="listItem">
                          <h6>Health Policy is process</h6>
                          <p>Your health policy has been processed.</p>
                        </MenuItem>
                      </Box>
                      <Box className="footer">
                        <Link
                          onClick={() => {
                            setActivePage("notifications");
                          }}
                          underline="none"
                          className="viewall"
                        >
                          View all
                        </Link>
                      </Box>
                    </Menu>
                  </React.Fragment>
                  {/* <-------Notification Menu End --------> */}
                  {/* <-------Sign Out Menu Start --------> */}
                  <React.Fragment>
                    <Box className="signoutMenu">
                      <IconButton
                        onClick={(e) => handleClick(e, "userSignOutStatus")}
                        aria-controls={
                          userSignOutStatus ? "account-menu" : undefined
                        }
                        aria-haspopup="true"
                        aria-expanded={userSignOutStatus ? "true" : undefined}
                      ></IconButton>
                    </Box>
                    <Menu
                      className="signout_option"
                      anchorEl={userSignOutStatus}
                      id="account-menu"
                      open={openSignOut}
                      onClose={() => handleClose("userSignOutStatus")}
                      onClick={() => handleClose("userSignOutStatus")}
                      PaperProps={{
                        elevation: 0,
                        sx: {
                          overflow: "visible",
                          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                          mt: 1.5,
                          "& .MuiAvatar-root": {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                          },
                          "&:before": {
                            content: '""',
                            display: "block",
                            position: "absolute",
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: "background.paper",
                            transform: "translateY(-50%) rotate(45deg)",
                            zIndex: 0,
                            paddingright: 0,
                          },
                        },
                      }}
                      transformOrigin={{ horizontal: "right", vertical: "top" }}
                      anchorOrigin={{
                        horizontal: "right",
                        vertical: "bottom",
                      }}
                    >
                      <MenuItem>Super Admin</MenuItem>
                      <MenuItem
                        onClick={() => {
                          updateMasterState("activePage", "setting");
                        }}
                      >
                        Change Password
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          navigate("/");
                        }}
                      >
                        Logout
                      </MenuItem>
                    </Menu>
                  </React.Fragment>
                  {/* <-------Sign Out Menu End --------> */}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid className="menuCol" item xs>
          <Box className="menus">
            {activePage == "setting" ? (
              <div className="subMenu">
                <ul>
                  <li>Settings</li>
                  <li>
                    <Link
                      underline="none"
                      className={settingPage == "password" ? "active" : ""}
                      onClick={() => setSettingPage("password")}
                    >
                      Password
                    </Link>
                  </li>
                  <li>
                    <Link
                      underline="none"
                      className={settingPage == "department" ? "active" : ""}
                      onClick={() => setSettingPage("department")}
                    >
                      Department
                    </Link>
                  </li>
                  <li>
                    <Link
                      underline="none"
                      className={settingPage == "location" ? "active" : ""}
                      onClick={() => setSettingPage("location")}
                    >
                      Location
                    </Link>
                  </li>
                  <li>
                    <Link
                      underline="none"
                      className={settingPage == "themes" ? "active" : ""}
                      onClick={() => setSettingPage("themes")}
                    >
                      Themes
                    </Link>
                  </li>
                  <li>
                    <Link
                      underline="none"
                      className={settingPage == "accessControl" ? "active" : ""}
                      onClick={() => setSettingPage("accessControl")}
                    >
                      Access Control
                    </Link>
                  </li>
                  <li>
                    <Link
                      underline="none"
                      className={settingPage == "users" ? "active" : ""}
                      onClick={() => setSettingPage("users")}
                    >
                      Users
                    </Link>
                  </li>
                </ul>
              </div>
            ) : null}
            {activePage == "productConfig" ? (
              <div className="subMenu">
                <ul>
                  <li>Products</li>
                  <li>
                    <Link
                      underline="none"
                      className={
                        productConfigPage == "groupHealth" ? "active" : ""
                      }
                      onClick={() => setProductConfigPage("groupHealth")}
                    >
                      Group Health
                    </Link>
                  </li>
                  <li>
                    <Link
                      underline="none"
                      className={
                        productConfigPage == "groupTerm" ? "active" : ""
                      }
                      onClick={() => setProductConfigPage("groupTerm")}
                    >
                      Group Term
                    </Link>
                  </li>
                  <li>
                    <Link
                      underline="none"
                      className={
                        productConfigPage == "groupPersonalAccident"
                          ? "active"
                          : ""
                      }
                      onClick={() =>
                        setProductConfigPage("groupPersonalAccident")
                      }
                    >
                      Group Personal Accident
                    </Link>
                  </li>
                  <li>
                    <Link
                      underline="none"
                      className={
                        productConfigPage == "superTopup" ? "active" : ""
                      }
                      onClick={() => setProductConfigPage("superTopup")}
                    >
                      Group Super Top-Up
                    </Link>
                  </li>
                  <li>
                    <Link
                      underline="none"
                      className={
                        productConfigPage == "groupCriticalIllness"
                          ? "active"
                          : ""
                      }
                      onClick={() =>
                        setProductConfigPage("groupCriticalIllness")
                      }
                    >
                      Group Critical Illness
                    </Link>
                  </li>
                  <li>
                    <Link
                      underline="none"
                      className={
                        productConfigPage == "groupTravel" ? "active" : ""
                      }
                      onClick={() => setProductConfigPage("groupTravel")}
                    >
                      Group Travel
                    </Link>
                  </li>
                  <li>
                    <Link
                      underline="none"
                      className={
                        productConfigPage == "voluntaryPlans" ? "active" : ""
                      }
                      onClick={() => setProductConfigPage("voluntaryPlans")}
                    >
                      Voluntary Plans
                    </Link>
                  </li>
                  <li>
                    <Link
                      underline="none"
                      className={
                        productConfigPage == "insurers" ? "active" : ""
                      }
                      onClick={() => setProductConfigPage("insurers")}
                    >
                      Insurers
                    </Link>
                  </li>
                  <li>
                    <Link
                      underline="none"
                      className={productConfigPage == "tpa" ? "active" : ""}
                      onClick={() => setProductConfigPage("tpa")}
                    >
                      Tpa
                    </Link>
                  </li>
                  <li>
                    <Link
                      underline="none"
                      className={
                        productConfigPage == "settings" ? "active" : ""
                      }
                      onClick={() => setProductConfigPage("settings")}
                    >
                      Settings
                    </Link>
                  </li>
                </ul>
              </div>
            ) : null}
            <TabList
              className={
                activePage == "dashboard" ? "dashboard active" : "dashboard"
              }
              buttonText={
                <p>
                  <span>D</span>ashboard
                </p>
              }
              attrname="activePage"
              value={"dashboard"}
              value_update={updateMasterState}
            />
            <TabList
              className={activePage == "quote" ? "quote active" : "quote"}
              buttonText={
                <p>
                  <span>Q</span>uotes
                </p>
              }
              attrname="activePage"
              value={"quote"}
              value_update={updateMasterState}
            />
            <TabList
              className={
                activePage == "policies" ? "policies active" : "policies"
              }
              buttonText={
                <p>
                  <span>P</span>olicies
                </p>
              }
              attrname="activePage"
              value={"policies"}
              value_update={updateMasterState}
            />
            <TabList
              className={
                activePage == "policyrenewal"
                  ? "endorsement active"
                  : "endorsement"
              }
              buttonText={
                <p>
                  <span>R</span>enewals
                </p>
              }
              attrname="activePage"
              value={"policyrenewal"}
              value_update={updateMasterState}
            />
            <TabList
              className={activePage == "clients" ? "clients active" : "clients"}
              buttonText={
                <p>
                  <span>C</span>lients
                </p>
              }
              attrname="activePage"
              value={"clients"}
              value_update={updateMasterState}
            />
            <TabList
              className={
                activePage == "contacts" ? "contacts active" : "contacts"
              }
              buttonText={
                <p>
                  Co<span>n</span>tacts
                </p>
              }
              attrname="activePage"
              value={"contacts"}
              value_update={updateMasterState}
            />
            <TabList
              className={activePage == "employe" ? "employe active" : "employe"}
              buttonText={
                <p>
                  <span>M</span>embers
                </p>
              }
              attrname="activePage"
              value={"employe"}
              value_update={updateMasterState}
            />
            <TabList
              className={
                activePage == "productConfig" ? "settings active" : "settings"
              }
              buttonText={
                <p>
                  Product Con<span>f</span>igurator
                </p>
              }
              attrname="activePage"
              value={"productConfig"}
              value_update={updateMasterState}
            />
            <TabList
              className={
                activePage == "endorsement"
                  ? "endorsement active"
                  : "endorsement"
              }
              buttonText={
                <p>
                  Endorsemen<span>t</span>
                </p>
              }
              attrname="activePage"
              value={"endorsement"}
              value_update={updateMasterState}
            />
            <TabList
              className={
                activePage == "claimassistant"
                  ? "claimassistant active"
                  : "claimassistant"
              }
              buttonText={
                <p>
                  C<span>l</span>aim
                </p>
              }
              attrname="activePage"
              value={"claimassistant"}
              value_update={updateMasterState}
            />
            {/* <TabList
              className={
                activePage == "taskManagement"
                  ? "taskmanagement active"
                  : "taskmanagement"
              }
              buttonText={
                <p>
                  Task Mana<span>g</span>ement
                </p>
              }
              attrname="activePage"
              value={"taskManagement"}
              value_update={updateMasterState}
            /> */}
            <TabList
              className={
                activePage == "trendingquestions"
                  ? "trendingquestions active"
                  : "trendingquestions"
              }
              buttonText={
                <p>
                  Trendin<span>g</span> Questions
                </p>
              }
              attrname="activePage"
              value={"trendingquestions"}
              value_update={updateMasterState}
            />
            <TabList
              className={
                activePage == "community" ? "community active" : "community"
              }
              buttonText={
                <p>
                  Co<span>m</span>munity
                </p>
              }
              attrname="activePage"
              value={"community"}
              value_update={updateMasterState}
            />
            <TabList
              className={activePage == "report" ? "report active" : "report"}
              buttonText={
                <p>
                  Rep<span>o</span>rt
                </p>
              }
              attrname="activePage"
              value={"report"}
              value_update={updateMasterState}
            />
            <TabList
              className={activePage == "support" ? "support active" : "support"}
              buttonText={
                <p>
                  S<span>u</span>pport
                </p>
              }
              attrname="activePage"
              value={"support"}
              value_update={updateMasterState}
            />
            {/* <TabList
              className={
                activePage == "setting" ? "settings active" : "settings"
              }
              buttonText={
                <p>
                  Sett<span>i</span>ng
                </p>
              }
              attrname="activePage"
              value={"setting"}
              value_update={updateMasterState}
            /> */}
          </Box>
        </Grid>

        {/* Main Content Section Start */}
        <Grid className="rightSection" item xs>
          {activePage == "dashboard" ? (
            <Dashboard value_update={updateMasterState} />
          ) : null}
          {activePage == "notifications" ? <Notifications /> : null}
          {activePage == "quote" ? (
            <Quotes addQuoteStatus={addQuoteStatus} />
          ) : null}
          {activePage == "policies" ? (
            <Policies addPolicy={addPolicyStatus} />
          ) : null}
          {activePage == "policyrenewal" ? <PolicyRenewal /> : null}
          {activePage == "clients" ? (
            <Clients addClient={addNewClient} />
          ) : null}
          {activePage == "contacts" ? (
            <Contacts addContact={addNewContact} />
          ) : null}
          {activePage == "employe" ? (
            <Employees addEmployee={addNewEmployee} />
          ) : null}
          {activePage == "userprofile" ? <Profile /> : null}
          {activePage == "report" ? <Report /> : null}
          {activePage == "claimassistant" ? (
            <Claimassistant intiateClaim={intiateClaim} />
          ) : null}
          {/* {activePage == "taskManagement" ? (
            <TaskManagement intiateClaim={intiateClaim} />
          ) : null} */}
          {activePage == "endorsement" ? (
            <Endorsement raiseRequest={raiseNewRequest} />
          ) : null}
          {activePage == "trendingquestions" ? (
            <TrendingQuestions postQuery={postQuery} />
          ) : null}
          {activePage == "community" ? (
            <Community postQuestion={postQuestion} />
          ) : null}
          {activePage == "support" ? <Support /> : null}
          {activePage == "profile" ? <Profile /> : null}
          {activePage === "users" ? <Users /> : null}
          {activePage == "productConfig" ? (
            <ProductConfig pageStatus={productConfigPage} />
          ) : null}
        </Grid>
      </Grid>

      {/* Search Popup */}
      <Modal
        className="modalWrapper"
        open={searchopen}
        onClose={() => {
          setSearchopen(false);
        }}
        aria-labelledby="User Search popup"
      >
        <div className="modalInner lg-width">
          <Box className="modalContent searchSection pb-6">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <input
                  className="searchField"
                  type="search"
                  placeholder="Search ..."
                ></input>
              </Grid>
              <Grid item xs={12}>
                <Tabs
                  // scrollButtons
                  // allowScrollButtonsMobile
                  value={searchType}
                  onChange={toggleProduct}
                  // variant="scrollable"
                  className="searchProductType"
                >
                  <ToggleButton value="all">All</ToggleButton>
                  <ToggleButton value="quotes">Quotes</ToggleButton>
                  <ToggleButton value="policies">Policies</ToggleButton>
                  <ToggleButton value="clients">Clients</ToggleButton>
                  <ToggleButton value="contacts">Contacts</ToggleButton>
                  <ToggleButton value="employees">Employees</ToggleButton>
                  <ToggleButton value="requests">Requests</ToggleButton>
                </Tabs>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={12} className="resultTitle">
                <p>RESULTS:</p>
              </Grid>
            </Grid>
            <Grid container spacing={2} className="allResults"></Grid>
          </Box>
        </div>
      </Modal>
    </Box>
  );
}
